const ContactEn = {
    contact: "Contact",
    address: "Address: 4/601 Little Collins Street, Melbourne Vic 3000",
    phone: "Phone: +61 03 9833 4890",
    abn: "ABN: 47 614 393 903",
    email: `Email: <a href='mailto:sales@blueshine.com.au' className={'email'}>sales@blueshine.com.au</a>`,

}

export default ContactEn;